import { ManualMuscleTestInputMethods } from "./ManualMuscleTestInputMethods";
import { ManualMuscleTestPresentMethods } from "./ManualMuscleTestPresentMethods";
import { IManualMuscleTestBehavior } from "./IManualMuscleTestBehavior";

export class ManualMuscleTestBehavior implements IManualMuscleTestBehavior {
  constructor(
    public inputMethod: ManualMuscleTestInputMethods      = ManualMuscleTestInputMethods.Click,
    public presentMethod: ManualMuscleTestPresentMethods  = ManualMuscleTestPresentMethods.Number,
  ) {
  }

  clone(): ManualMuscleTestBehavior {
    return new ManualMuscleTestBehavior(this.inputMethod, this.presentMethod);
  }

  static from(source: IManualMuscleTestBehavior): ManualMuscleTestBehavior {
    return new ManualMuscleTestBehavior(source.inputMethod, source.presentMethod);
  }

  static to(source: ManualMuscleTestBehavior): IManualMuscleTestBehavior {
    return {
      inputMethod: source.inputMethod,
      presentMethod: source.presentMethod,
    };
  }
}
